export const REMOVE_INTEREST = 'REMOVE_INTEREST';
export const ADD_INTEREST = 'ADD_INTEREST';

const removeInterest = id => ({
  type: REMOVE_INTEREST,
  id,
});

const addInterest = id => ({
  type: ADD_INTEREST,
  id,
});

export default {
  removeInterest,
  addInterest,
};
